<script setup>
import Header from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
</script>
<template>
  <div class="dashboard-layout">
    <Sidebar />
    <div class="dashboard-content">
      <Header />
  <main>
    <slot></slot>
  </main>
    </div>
  </div>
</template>
<style scoped>
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  height: 100%;
  align-items: stretch;
  background: #fff;
  position: relative;
  overflow-x: hidden;
}
.dashboard-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #fff;
  min-height: 100vh;
  height: 100%;
}

main {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0rem 0;
  box-sizing: border-box;
  overflow-y: auto;
}
</style>
